<template>
  <ServicePageType1
    :pageData="pageData"
    :service="pageData.defaultData.page"
  />
</template>
<script setup>
import { GoogleAnalyticsTrackPage } from '~/utils/googleAnalytics.js';
const tenthUrl = 'https://t1.kakaocdn.net/dkt_corp/service';
const pageData = {
  defaultData: {
    page: 'kakaoiauto',
    title: '카카오 i 오토',
    category: '음성 AI',
    slogan: '말 한마디로<br>편리해지는 일상',
    image: `${tenthUrl}/img_auto.png`,
    siblingPages: {
      linksType: 'scroll',
      list: [
        {
          title: '카카오 i',
          link: '/kakaoi',
          isSelected: false,
        },
        {
          title: '카카오 i 오토',
          link: '/kakaoiauto',
          isSelected: true,
        },
        {
          title: '카카오홈',
          link: '/kakaohome',
          isSelected: false,
        },
      ],
    },
  },
  seoData: {
    description: '말 한마디로 편리해지는 일상',
  },
  worryData: {
    title: '어떻게<br>사용되고 있나요?',
    list: [
      "#차량 제어 '에어컨 틀어줘' '조수석 창문 열어줘'",
      "#길 안내 '집으로 가는 가장 빠른 길로 안내해 줘'  '근처 주유소 찾아줘'",
      "#카카오톡 '방금 온 카톡 읽어줘' '지금 출발한다고 답장 보내줘'",
      "#위치공유 '도착지 공유해줘' '현재 위치 알려줘' ",
    ],
  },
  solutionData: {
    title: '차량과 대화하며<br>안전한 운전 환경을 누려보세요',
    list: [
      {
        color: '#D1E8FE',
        desc: '모빌리티 환경에 최적화된 \n음성 AI 서비스를 경험해요',
        image: `${tenthUrl}/img_solution_auto1.png`,
        imgSize: '790',
      },
      {
        color: '#F8F8F8',
        desc: '멀티미디어, 날씨 정보, 정보 검색, 카카오톡 등 카카오 그룹의 다양한 콘텐츠와 서비스와 연결되어 있어요',
        image: `${tenthUrl}/img_solution_auto2.png`,
        imgSize: '916',
      },
      {
        color: '#F5F5F7',
        desc: '높은 음성 인식률을 보유한 AI 기술로 \n소음이 많은 차 안에서 \n사용자 의도를 정확하게 파악해요',
        image: `${tenthUrl}/img_solution_auto3_250113.png`,
        imgSize: '916',
      },
      {
        color: '#F5F5F7',
        desc: '교통정보, 차량 제어 등 운전에 필요한 기능을 음성으로 실행하고 이용할 수 있어요',
        image: `${tenthUrl}/img_solution_auto4.png`,
        imgSize: '790',
      },
    ],
  },
  specialData: {
    link: 'https://kakao.ai/',
    list: [
      {
        title: '내비게이션 x 카카오 i',
        desc: '운전 중에 필요한 게 있나요? 카카오 i에게 말해주세요 \n목적지 안내와 근처 주유소 검색, 카카오톡 답장, 음악 재생까지 말 한마디로 가능해요',
        thumbPc: `${tenthUrl}/img_special_pc_auto1.png`,
        thumbMo: `${tenthUrl}/img_special_mo_auto1.png`,
      },
      {
        title: '자동차 x 카카오 i',
        desc: '차 안에서 음성인식으로 다양한 기능을 경험하세요 안전한 운전은 필수! \n음성으로 안전하게 목적지를 찾고 전화를 연결하고 차량을 제어할 수 있어요',
        thumbPc: `${tenthUrl}/img_special_pc_auto2.png`,
        thumbMo: `${tenthUrl}/img_special_mo_auto2.png`,
      },
    ],
  },
};

onMounted(() => {
  GoogleAnalyticsTrackPage('kakaoiauto', '카카오i오토_PV');
});
</script>
